// 環境変数
app.value('analysisConfig', {
    'serverUrl' :'https://lirs.jp',
    'apiKey' : 'aa18388b1d0744f6ab6bed3d6069a590',
    'apiEndpoint' : 'https://lir-predict-dish-demo.work/api/',
    'mode' : 1 // 0:scc, 1:clarifai
})

// 食事解析キーワード
app.factory('analysisKeyword', function() {
    return {
        // SCCAI用の食事解析キーワード
        sccai : {
            'maindish' : ['ご飯', 'ピザ', 'トースト', 'ハンバーガー', 'サンドイッチ', 'パン', 'ラーメン', 'ヌードル', 'コーンフレーク', '穀物', 'パスタ', '鍋', 'カレー', 'うどん'],
            'meet'     : ['お肉', 'チキン', '豚肉', '牛肉', 'ビーフ', 'ミート', 'ソーセージ'],
            'egg'      : ['卵'],
            'fish'     : ['魚', 'シーフード'],
            'beans'    : ['豆', '豆腐'],
            'sub'      : ['サラダ', '野菜'],
            'soup'     : ['スープ'],
            'fruits'   : ['フルーツ'],
            'milk'     : ['ミルク']
        },
        // clarifai用の食事解析キーワード
        clarifai : {
            'maindish' : ['rice', 'pizza', 'toast', 'hamburger', 'sandwich', 'bread', 'ramen', 'noodle', 'cornflakes', 'cereal', 'pasta'],
            'meet'     : ['meat', 'chicken', 'pork', 'beef', 'sausage'],
            'egg'      : ['egg'],
            'fish'     : ['fish', 'seafood'],
            'beans'    : ['beans', 'tofu'],
            'sub'      : ['salad', 'vegetable'],
            'soup'     : ['soup'],
            'fruits'   : ['fruit'],
            'milk'     : ['milk']
        }
    }
});
